<template>
<div class="main-wrapper">
  <layout-header />
  <layout-sidebar />

  <a-spin :spinning="isDataLoading">
  <div class="page-wrapper">
    <div class="content container-fluid scheduler-wrapper">

		<shift-header
          :title="title"
          :path="path"
          :text="text"
          :text1="text1"
          :text2="text2"
          :text3="text3"
          :text4="text4"
          :search_data="searchData2"
          :columns="columns"
          :current-week-start="currentWeekStart"
          :current-week-end="currentWeekEnd"
          @add-shift="openAddShiftModel"
          @add-schedule="openAddScheduleModel"
          @add-dept-schedule="openAddDeptScheduleModel"
          @copy-week="handleCopyWeek"
        />
		
		<shift-scheduling-filter
          :hasEditPermission="hasEditPermission"
          @search-schedule="searchSchedule"
          :sDate="sDate"
          :eDate="eDate"
        />
		
		<div class="mb-3">
  <button
    class="btn btn-success"
    data-bs-toggle="modal"
    data-bs-target="#add_schedule">
    🔍 Open Add Schedule Modal (TEST)
  </button>
</div>


		
		
      <div class="scheduler">

		<div class="scheduler-scroll">
		
			<!-- PALETTE -->
			
			<!--
			<div class="palette-fixed">
			  <div ref="palette" class="palette-row">
				<div
				  v-for="s in shifts"
				  :key="s.shift_id"
				  class="shift-box"
				  :style="{ background: assignShiftBGColor(s.shift_id) }"
				  :data-id="s.shift_id"
				>
				  <b>{{ s.shift_name }}</b>
				  <small>{{ s.start_time }} - {{ s.end_time }}</small>
				</div>
			  </div>
			</div> -->
			
			
			<!-- PALETTE -->
			<div class="palette-strip">
			  <div ref="palette" class="palette-inner">
				<div
				  v-for="s in shifts"
				  :key="s.shift_id"
				  class="shift-box"
				  :data-id="s.shift_id"
				  :style="{ background: assignShiftBGColor(s.shift_id) }"
				>
				  <div class="shift-title">{{ s.shift_name }} {{ hasEditPermission }}</div>
				  <div class="shift-time">
					{{ s.start_time }} - {{ s.end_time || 'Not Set' }}
				  </div>
				</div>

			  </div>
			</div>






			<!-- GRID -->
        

          <div class="grid">
            <div class="cell head emp">Employee</div>
            <div class="cell head" v-for="d in dates" :key="d">
              {{ formatDay(d) }}
            </div>
          </div>

          <div
            class="grid row"
            v-for="emp in scheduleData"
            :key="emp.id"
          >
            <div class="cell emp">
              {{ emp.first_name }} {{ emp.last_name }}
            </div>

            <div v-for="d in dates" :key="d" class="cell drop-cell">

			  <!-- EMPTY CLICK AREA -->
			  <div v-if="!emp[d]?.length"
				   class="cell-click-area"
				   @click="openAddFromCell(emp, d)">
				+
			  </div>

			  <!-- DRAG / EVENT ZONE -->
			  <div class="cell-sortable-area"
				   :ref="el => registerCell(el, emp.id, d)">

				<div v-for="a in emp[d]"
					 :key="a.schedule_id"
					 class="assigned"
					 :data-shift-id="a.shift_id"
					 :style="{ background: assignShiftBGColor(a.shift_id) }"
					 @click.stop="openEditFromCell(a)">
				  <div class="assigned-title">{{ a.shift?.shift_name }}</div>
				  <div class="assigned-time">{{ a.shift?.start_time }} - {{ a.shift?.end_time }}</div>
				</div>

			  </div>
			</div>




          </div>

        </div>
      </div>
    </div>
	<teleport to="body">

  <shift-list-model
    @delete-shift="deleteShift"
    :deleteId="deleteID"
    :editShift="editShift"
    :closeModal="closeModal"
  />

  <edit-schedule-model
    :addEmployeeId="addEmployeeId"
    :editSchedule="editSchedule"
    @add-schedule="openAddScheduleModel"
    @reload-data="fetchScheduleData"
  />

  <dept-schedule-model
    @add-dept-schedule="openAddDeptScheduleModel"
    @reload-data="fetchScheduleData"
  />

</teleport>

  
  </div>
  </a-spin>

</div>
</template>

<script>
import Sortable from "sortablejs";
import axios from "axios";
import moment from "moment";
import { notification } from "ant-design-vue";
import { Modal } from "bootstrap";

export default {
data(){
  return {
	sDate: null,
    eDate: null,
	showEditModal:false,
	showDeptModal:false,
	showShiftModal:false,
	searchData2: null,
    columns: [],
	currentWeekStart: null,
    currentWeekEnd: null,
    shifts: [],
    scheduleData: [],
    dates: [],
    startDayOfWeek: "Monday",
    isDataLoading: false,
	hasCreatePermission:true,
    hasEditPermission:true,
    title:"Daily Scheduling",
	path:"Dashboard",
	  text:"Employees",
	  text1:"Shift Scheduling",
	  text2:"Shifts",
	  text3:"Assign Shifts",
	  text4:"Assign Department Shifts",
	  addEmployeeId:null,
editSchedule:null,
deleteID:null,
editShift:null,
closeModal:false,


	
  }
},
mounted(){
  this.fetchWeekDay();
  this.initPalette();
},
watch:{
  addEmployeeId(v){
    if(v){
      this.$nextTick(()=> this.addEmployeeId = this._forceModal(v));
    }
  },
  editSchedule(v){
    if(v){
      this.$nextTick(()=> this.editSchedule = this._forceModal(v));
    }
  },
  editShift(v){
    if(v){
      this.showShiftModal = false;
      this.$nextTick(()=> this.showShiftModal = true);
    }
  }
},

methods:{
_force(obj){
  return JSON.parse(JSON.stringify(obj));
},
_forceModalRefresh(){
  this.addEmployeeId = null;
  this.editSchedule = null;
},

_forceModal(obj){
  return { ...obj, __force: Date.now() };
},
openAddFromCell(emp, d){

	console.log('sbc');
	
  this.onAddSchedule(emp.id, d, emp.emp_department_id);
  this.openBootstrapModal("add_schedule");
},

openEditFromCell(a){

	console.log('sbc2');
	
  this.onEditSchedule(a);
  this.openBootstrapModal("add_schedule");
},
openBootstrapModal(id){
  this.$nextTick(()=>{
    const el = document.getElementById(id);
    if(!el) return;
    Modal.getOrCreateInstance(el).show();
  });
},
searchSchedule(params) {
  this.searchData2 = params;
  this.fetchScheduleData(params);
},
async handleCopyWeek(targetWeek){

  const payload = {
    current_week_start: this.currentWeekStart,
    current_week_end: this.currentWeekEnd,
    target_week_start: targetWeek.startDate,
    target_week_end: targetWeek.endDate,
  };

  let loader = this.$loading.show({ container:this.$el });

  try{
    const res = await axios.post("schedule/copy-schedules", payload);
    this.fetchScheduleData();

    notification.open({
      message: res.data.message || "Week copied successfully",
      placement: "topRight",
      duration: process.env.VUE_APP_NOTIFICATION_DURATION,
      style: { background: process.env.VUE_APP_SUCCESS_COLOR }
    });

  }catch(error){

    const r = error.response;
    notification.open({
      message: r?.data?.message || "Failed to copy week",
      placement: "topRight",
      duration: process.env.VUE_APP_NOTIFICATION_DURATION,
      style: { background: process.env.VUE_APP_WARNING_COLOR }
    });

  }finally{
    loader.hide();
  }
},


calculateWeekDates(){
  let startDate = moment();
  while (startDate.format("dddd") !== this.startDayOfWeek) {
    startDate.subtract(1, "day");
  }
  return {
    currentWeekStart: startDate.format("YYYY-MM-DD"),
    currentWeekEnd: moment(startDate).add(6, "days").format("YYYY-MM-DD"),
  };
},

setCurrentWeekDates(){
  const { currentWeekStart, currentWeekEnd } = this.calculateWeekDates();
  this.currentWeekStart = currentWeekStart;
  this.currentWeekEnd = currentWeekEnd;
},

openAddShiftModel(){
  this.editShift = null;
},

openAddScheduleModel(){
  this.addEmployeeId = null;
  this.editSchedule = null;
},

openAddDeptScheduleModel(){
  this.editSchedule = null;
},

deleteShift(id){
  this.deleteID = id;
},

onAddSchedule(empId, date, deptId){
  this.addEmployeeId = null;
  this.$nextTick(()=>{
    this.addEmployeeId = this._force({ id: empId, date, department_id: deptId });
  });
},

onEditSchedule(schedule){
  this.editSchedule = null;
  this.$nextTick(()=>{
    this.editSchedule = this._force(schedule);
  });
},

initPalette(){
  if(this.$refs.palette._sortable) return;
  this.$refs.palette._sortable = true;

  Sortable.create(this.$refs.palette,{
    group:{ name:"shifts", pull:"clone", put:false },
    sort:false,
    animation:150,
    forceFallback:true,
    fallbackOnBody:true,
    touchStartThreshold:10,

    // 🔥 allow clicks to pass through
    filter: '.cell-click-layer, .assigned',
    preventOnFilter:false
  });
},


registerCell(el, emp, date){
  if(!el || el._sortable) return;
  el._sortable = true;

  Sortable.create(el,{
    group:"shifts",
    animation:180,
    forceFallback:true,
    fallbackOnBody:true,
    touchStartThreshold:10,
    onAdd: evt => this.onDrop(evt, emp, date)
  });
},

async onDrop(evt, emp, date){

  const fromCell = evt.from;    // source DOM
  const toCell   = evt.to;      // target DOM

  let shift_id = null;
  let movedSchedule = null;

  // palette → cell
  if (evt.from === this.$refs.palette) {
    shift_id = +evt.item.dataset.id;
  }
  // cell → cell
  else {
    shift_id = +evt.item.getAttribute("data-shift-id");
  }

  evt.item.remove();

  const record = this.scheduleData.find(e => e.id === emp);
  record[date] ||= [];

  // Find source employee+date if cell→cell
  let sourceRecord = null, sourceDate = null;
  if (evt.from !== this.$refs.palette) {
    for (const r of this.scheduleData) {
      for (const d of this.dates) {
        if (r[d]?.some(s => s.shift_id === shift_id)) {
          sourceRecord = r;
          sourceDate = d;
        }
      }
    }
    if (sourceRecord && sourceDate) {
      movedSchedule = sourceRecord[sourceDate].find(s => s.shift_id === shift_id);
      sourceRecord[sourceDate] =
        sourceRecord[sourceDate].filter(s => s.shift_id !== shift_id);
    }
  }

  if (record[date].some(s => s.shift_id === shift_id)) return;

  const shift = movedSchedule || this.shifts.find(s => s.shift_id === shift_id);

  const newSchedule = {
    shift_id: shift.shift_id,
    start_time: shift.start_time,
    end_time: shift.end_time,
    emp_department_id: record.emp_department_id,
    shift: shift
  };

  record[date].push(newSchedule);

  const payload = {
    record: { id: emp },
    key: [emp, date],
    date_data: record[date]
  };

  let loader = this.$loading.show({ container: this.$el });

  try {
    const res = await axios.post("/schedule/dragged-schedule-data", payload);

    await this.fetchScheduleData(false);

    notification.open({
      message: res.data.message,
      placement: "topRight",
      duration: process.env.VUE_APP_NOTIFICATION_DURATION,
      style: { background: process.env.VUE_APP_SUCCESS_COLOR }
    });

  } catch (error) {

    // 🔥 FULL ROLLBACK
    record[date].pop();
    if (sourceRecord && sourceDate && movedSchedule) {
      sourceRecord[sourceDate].push(movedSchedule);
    }

    await this.fetchScheduleData(false);

    const r = error.response;
    notification.open({
      message: r?.data?.message || "Shift conflict",
      placement: "topRight",
      duration: process.env.VUE_APP_NOTIFICATION_DURATION,
      style: { background: process.env.VUE_APP_WARNING_COLOR }
    });

  } finally {
    loader.hide();
  }
},
async fetchWeekDay(){
  let token = localStorage.getItem("token");
  axios.defaults.headers.common.Authorization = "Bearer "+token;

  const r = await axios.get("/globalsettings/shiftsettings");
  const v = r.data.data.find(i=>i.global_settings_key==="start_day_of_week");
  this.startDayOfWeek = v?.global_settings_value || "Monday";
  this.setCurrentWeekDates();

  this.buildDates();
  await this.getAllShiftList();
  this.fetchScheduleData();
},

buildDates(){
  let s = moment();
  while(s.format("dddd")!==this.startDayOfWeek) s.subtract(1,"day");
  this.dates=[];
  for(let i=0;i<7;i++){
    this.dates.push(s.format("YYYY-MM-DD"));
    s.add(1,"day");
  }
},

async getAllShiftList(){
  const r = await axios.get("shifts/all");
  this.shifts = r.data.data || [];
},

async fetchScheduleData(showLoader=true){
  this.isDataLoading=true;
  const r = await axios.get("schedule/list",{params:{
    start_date:this.dates[0],
    end_date:this.dates[6]
  }});
  this.scheduleData = r.data.data.data || [];
  this.isDataLoading=false;
},

assignShiftBGColor(id){
  const colors = ["#FF0000","#0000FF","#FF00FF","#808000","#8B4513","#F82F72"];
  return colors[id % colors.length] + "2a";
},

formatDay(d){
  return moment(d).format("ddd D");
}

}
}
</script>

<style scoped>
.drop-cell{position:relative;min-height:65px;}
.cell-click-area{
  position:absolute;
  inset:0;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:26px;
  color:#cfcfcf;
  cursor:pointer;
  z-index:5;   /* ABOVE sortable */
}

.cell-sortable-area{position:relative;display:flex;flex-direction:column;gap:4px;}
.cell-click-layer{
  position:absolute;
  inset:0;
  z-index:1;        /* LOWER than assigned */
  cursor:pointer;
}
.assigned{
  position:relative;
  z-index:2;        /* ABOVE click layer */
}


.shift-title{
  font-weight:600;
  font-size:14px;
}

.shift-time{
  margin-top:4px;
  font-size:12px;
  opacity:.7;
}


.palette-strip{
  position:sticky;
  top:0;
  background:#fff;
  z-index:5;
  padding-bottom:12px;
}

.palette-inner{
  display:flex;
  gap:12px;
  min-width:max-content;     /* allows horizontal scroll */
}

.shift-box{
  min-width:190px;
  padding:14px;
  border-radius:12px;
  cursor:grab;
  box-shadow:0 3px 8px rgba(0,0,0,.12);
  white-space:nowrap;
}


.scheduler{padding:20px;font-family:Segoe UI;--dayWidth:190px}
.palette-fixed{
  background:#fff;
  padding-bottom:10px;
}
.shift-box{width:190px;padding:14px;border-radius:12px;cursor:grab;box-shadow:0 3px 8px rgba(0,0,0,.12)}
.scheduler-scroll{overflow-x:auto}
.grid{display:grid;grid-template-columns:220px repeat(7,var(--dayWidth))}
.cell{border-bottom:1px solid #eee;padding:10px;text-align:center}
.head{background:#fafafa;font-weight:600;border-bottom:2px solid #ddd}
.emp{text-align:left;font-weight:600}
.drop-cell{min-height:65px;border:1px dashed #ddd;border-radius:8px;display:flex;flex-direction:column;gap:4px;padding:4px}


.assigned{width:100%;padding:6px 10px;border-radius:8px;font-size:12px;text-align:left}
.assigned-title{font-weight:600}
.assigned-time{font-size:11px;opacity:.75}
</style>
